export interface SmithersDeviceConfig {
  id: number
  deviceId: string
  sotiDeviceId: string
  clientId: string
  createdAt: string
  inheritedFromGlobal: string[]
  requiresProVenueInstance: boolean
  validationVendor: "ProVenue" | "Orion"
  facilityCode: string
  venueId: string
  areaCode: string
  deviceCode: string
  nteClubCode: string
  matchThreshold: number
  validationTimeoutMs: number
  proVenueInstanceId: number | null
  proVenueUser: string
  proVenueInstances: { name: string; hostName: string }[]
  updatedAt: string
  updatedBy: string
}

export interface SmithersDevicePage {
  items: SmithersDeviceConfig[]
  total: number
  page: number
  pageSize: number
}

export type SmithersDeviceSortField = Exclude<keyof SmithersDeviceConfig, "id" | "inheritedFromGlobal" | "proVenueInstances" | "requiresProVenueInstance">
export interface SmithersDeviceListParams {
  page?: number
  pageSize?: number
  filter?: string
  sortBy?: SmithersDeviceSortField
  sortOrder?: "asc" | "desc"
}

export interface CreateSmithersDeviceRequest {
  clientId: string
  deviceId: string
  sotiDeviceId: string
  validationVendor?: "ProVenue" | "Orion"
  facilityCode?: string
  venueId?: string
  areaCode?: string
  deviceCode?: string
  nteClubCode?: string
  matchThreshold?: number
  validationTimeoutMs?: number
  requiresProVenueInstance: boolean
  proVenueInstanceId?: number
}

export type UpdateSmithersDeviceRequest = Omit<CreateSmithersDeviceRequest, "clientId" | "deviceId" | "sotiDeviceId">

export const MAX_SMITHERS_BULK_DEVICES = 200

export interface BulkDeleteSmithersDeviceResult {
  id: number
  status: "deleted" | "failed"
  clientId?: string
  deviceId?: string
  error?: string
}

export interface BulkDeleteSmithersDevicesResult {
  results: BulkDeleteSmithersDeviceResult[]
  deleted: number
  failed: number
}

type SmithersBulkUpdateField = Exclude<keyof UpdateSmithersDeviceRequest, "requiresProVenueInstance">
export type SmithersBulkUpdatePatch = Partial<{ [K in SmithersBulkUpdateField]: Exclude<UpdateSmithersDeviceRequest[K], undefined> | null }> & { requiresProVenueInstance?: boolean }
export interface BulkUpdateSmithersDevicesRequest {
  ids: number[]
  update: SmithersBulkUpdatePatch
}
export interface BulkUpdateSmithersDevicesResult {
  requestedCount: number
  successCount: number
  failureCount: number
  failedDevices: { id: number; status: number; code: string; message: string }[]
}
